module.exports = __webpack_public_path__ + "img/0Q3B2213_BlackMatted.fd797921.jpg";